<template>
	<div class="content-wrapper">
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<app-breadcrumb
					:page-title="$t('payment_status')"
					:directory="$t('master')"
					:icon="'grid'"
				/>
			</div>
			<div class="col-sm-12 col-md-6 breadcrumb-side-button">
				<div class="float-md-right mb-3 mb-sm-3 mb-md-0">
					<button
						type="button"
						class="btn btn-success btn-with-shadow"
						@click="exportAll"
					>
						{{ $t("export_all") }}
					</button>
					<button
						type="button"
						class="btn btn-primary btn-with-shadow"
						data-toggle="modal"
						@click="openAddEditModal"
					>
						{{ $t("add") }}
					</button>
				</div>
			</div>
		</div>

		<app-table :id="tableId" :options="options" @action="getListAction" />

		<modal-form
			v-if="isAddEditModalActive"
			:table-id="tableId"
			:form-id="formId"
			v-model="rowData"
			:selected-url="selectedUrl"
			@close-modal="closeAddEditModal"
		/>

		<app-delete-modal
			v-if="deleteConfirmationModalActive"
			:preloader="deleteLoader"
			modal-id="demo-delete"
			@confirmed="onDelete"
			@cancelled="onCancelDelete"
		/>
	</div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import { Schema } from "./Schema";
import { urlGenerator } from "../../../../Helpers/AxiosHelper";

export default {
	extends: CoreLibrary,
	name: "PaymentStatus",
	mixins: [Schema],
	created() {
		this.options.columns = [...this.tableColumns, this.actionObj];
		// this.searchAndSelectFilterOptions();
	},
	methods: {
		/**
		 * for open add edit modal
		 */
		openAddEditModal() {
			this.isAddEditModalActive = true;
		},

		/**
		 * for close add edit modal
		 */
		closeAddEditModal() {
			let m_id = `#payment-status-form`;
			$(m_id).modal("hide");
			this.isAddEditModalActive = false;
			// this.searchAndSelectFilterOptions();
			this.reSetData();
		},

		/**
		 * $emit Form datatable action
		 */
		getListAction(rowData, actionObj, active) {
			this.rowData = rowData;
			if (actionObj.title == "Delete") {
				this.openDeleteModal();
			} else if (actionObj.title == this.$t("edit")) {
				this.selectedUrl = `${this.ENDPOINT}/${rowData.id}`;
				this.openAddEditModal();
			}
		},

		/**
		 * for open confirmation modal
		 */
		openDeleteModal() {
			this.deleteConfirmationModalActive = true;
		},

		// searchAndSelectFilterOptions() {
		//     this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then(response => {
		//         let name = this.options.filters.find(element => element.title === this.$t('search_and_select'));

		//         name.option = response.data.map(name => {
		//             return {
		//                 id: name.name,
		//                 value: name.name
		//             }
		//         });
		//     });
		// },

		exportAll() {
			window.location.replace(urlGenerator(DATATABLE_EXPORT));
		},
	},
};
</script>
